import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type {
  CreateScheduleRequest,
  CreateScheduleResponse,
  DeleteScheduleRequest,
  DeleteScheduleResponse,
  UpdateScheduleRequest,
  UpdateScheduleResponse,
} from './dto';
import { ScheduleAPIRoutes } from './route';

export function createSchedule(body: CreateScheduleRequest): Promise<CreateScheduleResponse> {
  return makeRequest(api.post(ScheduleAPIRoutes.createNewSchedule(), body));
}

export function updateSchedule(body: UpdateScheduleRequest): Promise<UpdateScheduleResponse> {
  return makeRequest(api.post(ScheduleAPIRoutes.updateSchedule(), body));
}

export function deleteSchedule(body: DeleteScheduleRequest): Promise<DeleteScheduleResponse> {
  return makeRequest(api.post(ScheduleAPIRoutes.deleteSchedule(), body));
}
